import { Children } from "react";
import * as yup from "yup";
import { FormGroup } from "../../../../components/form";

const today = new Date();
const threeMonthsFuture = new Date();
threeMonthsFuture.setMonth(today.getMonth() + 3);

export const applicationChecklistFormLegacy = (toggle: (values: any) => void) => {
  const form: FormGroup = {
    type: "formGroup",
    warn: "Complete the following checklist relating to the KIS application",
    disabledExpression: (context, values) => values.emailStatus != ChecklistEmailStatus.NoEmailSent && values.emailStatus != null,
    fields: [
      {
        type: "field",
        fieldType: "advisory",
        props: {
          type: "warning",
        },
        key: "advisory",
        label: "Responses recorded in this application will be included in the advisory email sent to the kindergarten regarding their application.",
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "sectionOneNotProvided",
        label: "Section 1 not provided",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "sectionOneNotProvidedDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.sectionOneNotProvided,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "kindergartenNameMismatch",
        label: "Kindergarten name mismatch",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "kindergartenNameMismatchDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.kindergartenNameMismatch,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "teacherNameMissing",
        label: "Teacher name missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "teacherNameMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.teacherNameMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "teacherSignatureMissing",
        label: "Teacher signature missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "teacherSignatureMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.teacherSignatureMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "eymSignatureMissing",
        label: "EYM signature missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "eymSignatureMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.eymSignatureMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "yearTeacherPreviouslyAccessedSupportMissing",
        label: "Year teacher previously accessed support missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "yearTeacherPreviouslyAccessedSupportMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.yearTeacherPreviouslyAccessedSupportMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "previousSupportTypeMissing",
        label: "Previous support type is missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "previousSupportTypeMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.previousSupportTypeMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "attendanceHoursUnclearMissing",
        label: "Attendance hours unclear/missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "attendanceHoursUnclearMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.attendanceHoursUnclearMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "kinderGroupNameMissing",
        label: "Kinder group name missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "kinderGroupNameMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.kinderGroupNameMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "groupSizeMissing",
        label: "Group size missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "groupSizeMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.groupSizeMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "rotationalGroupsMissing",
        label: "Rotational groups missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "rotationalGroupsMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.rotationalGroupsMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "staffToChildRatioMissing",
        label: "Staff to child ratio missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "staffToChildRatioMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.staffToChildRatioMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "indoorOutdoorProgramMissing",
        label: "Indoor/outdoor program missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "indoorOutdoorProgramMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.indoorOutdoorProgramMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "programOverviewSectionsBlank",
        label: "Program overview section/s blank",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "programOverviewSectionsBlankDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.programOverviewSectionsBlank,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "otherSupportDescriptionIncomplete",
        label: "Other support description incomplete",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "otherSupportDescriptionIncompleteDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.otherSupportDescriptionIncomplete,
      },

      // Section 2 Fields
      {
        type: "field",
        fieldType: "checkbox",
        key: "section2NotProvided",
        label: "Section 2 not provided",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "section2NotProvidedDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.section2NotProvided,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "additionalStaffDescriptionMissing",
        label: "Additional staff description missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "additionalStaffDescriptionMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.additionalStaffDescriptionMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "parentSignatureMissing",
        label: "Parent signature missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "parentSignatureMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.parentSignatureMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "applicationTypeMissing",
        label: "Application type missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "applicationTypeMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.applicationTypeMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "psgTableIncomplete",
        label: "PSG table incomplete",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "psgTableIncompleteDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.psgTableIncomplete,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "psgConvenorNameMissing",
        label: "PSG convenor name missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "psgConvenorNameMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.psgConvenorNameMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "psgFirstMeetingDateMissing",
        label: "PSG first meeting date missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "psgFirstMeetingDateMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.psgFirstMeetingDateMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "psgFutureDatedTBC",
        label: "PSG future dated/TBC",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "psgFutureDatedTBCDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.psgFutureDatedTBC,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "childDOBMissing",
        label: "Child DOB missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "childDOBMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.childDOBMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "childGenderMissing",
        label: "Child gender missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "childGenderMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.childGenderMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "birthInAustraliaOSBlank",
        label: "Birth in Australia/OS blank",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "birthInAustraliaOSBlankDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.birthInAustraliaOSBlank,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "osBirthCountryMissing",
        label: "OS birth country missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "osBirthCountryMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.osBirthCountryMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "eslMissing",
        label: "ESL missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "eslMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.eslMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "languageSpokenMissing",
        label: "Language spoken missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "languageSpokenMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.languageSpokenMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "firstNationsOriginMissing",
        label: "First Nations origin missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "firstNationsOriginMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.firstNationsOriginMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "parentDetailsBlank",
        label: "Parent details blank",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "parentDetailsBlankDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.parentDetailsBlank,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "yearAppliedForMissing",
        label: "Year applied for missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "yearAppliedForMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.yearAppliedForMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "programTypeMissing",
        label: "Program type (3/4/ESK) missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "programTypeMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.programTypeMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "secondYear4yoMissing",
        label: "Second year 4yo missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "secondYear4yoMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.secondYear4yoMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "childTurning6Missing",
        label: "Child turning 6 missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "childTurning6MissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.childTurning6Missing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "schoolExemptionMissing",
        label: "School exemption missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "schoolExemptionMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.schoolExemptionMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "commencementDateMissing",
        label: "Commencement date missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "commencementDateMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.commencementDateMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "secondRoundReasonMissing",
        label: "Second round reason missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "secondRoundReasonMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.secondRoundReasonMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "outOfRoundReasonMissing",
        label: "Out of round reason missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "outOfRoundReasonMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.outOfRoundReasonMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "reasonsForSupportMissing",
        label: "Reasons for support missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "reasonsForSupportMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.reasonsForSupportMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "disabilityDiagnosisMissing",
        label: "Disability/diagnosis missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "disabilityDiagnosisMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.disabilityDiagnosisMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "interestsMissing",
        label: "Interests missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "interestsMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.interestsMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "strengthsAndAbilitiesMissing",
        label: "Strengths and abilities missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "strengthsAndAbilitiesMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.strengthsAndAbilitiesMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "physicalMissing",
        label: "Physical missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "physicalMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.physicalMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "fineMotorMissing",
        label: "Fine motor missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "fineMotorMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.fineMotorMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "communicationMissing",
        label: "Communication missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "communicationMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.communicationMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "learningMissing",
        label: "Learning missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "learningMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.learningMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "socialMissing",
        label: "Social missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "socialMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.socialMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "selfCareMissing",
        label: "Self-care missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "selfCareMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.selfCareMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "behavioursMissing",
        label: "Behaviours missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "behavioursMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.behavioursMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "evidenceCollectionLocationMissing",
        label: "Evidence collection location missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "evidenceCollectionLocationMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.evidenceCollectionLocationMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "kisPlanMissingIncomplete",
        label: "KIS plan missing/incomplete",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "kisPlanMissingIncompleteDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.kisPlanMissingIncomplete,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "existingResourcesMissing",
        label: "Existing resources missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "existingResourcesMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.existingResourcesMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "allAdditionalSupportMissing",
        label: "All additional support missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "allAdditionalSupportMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.allAdditionalSupportMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "additionalAssistantMissing",
        label: "Additional assistant missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "additionalAssistantMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.additionalAssistantMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "specialistConsultancyMissing",
        label: "Specialist consultancy missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "specialistConsultancyMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.specialistConsultancyMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "specialistTrainingMissing",
        label: "Specialist training missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "specialistTrainingMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.specialistTrainingMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "minorModificationsQuotesMissing",
        label: "Minor modifications quotes missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "minorModificationsQuotesMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.minorModificationsQuotesMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "cmnDiagnosisMissing",
        label: "CMN diagnosis missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "cmnDiagnosisMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.cmnDiagnosisMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "healthSupportProceduresMissing",
        label: "Health support procedures missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "healthSupportProceduresMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.healthSupportProceduresMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "frequencyOfMedicalSupportMissing",
        label: "Frequency of medical support missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "frequencyOfMedicalSupportMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.frequencyOfMedicalSupportMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "whoWillProvideMedicalSupportMissing",
        label: "Who will provide medical support missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "whoWillProvideMedicalSupportMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.whoWillProvideMedicalSupportMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "additionalMedicalTrainingMissing",
        label: "Additional medical training missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "additionalMedicalTrainingMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.additionalMedicalTrainingMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "medicalManagementPlanMissing",
        label: "Medical management plan missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "medicalManagementPlanMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.medicalManagementPlanMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "riskMinimisationPlanMissing",
        label: "Risk minimisation plan missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "riskMinimisationPlanMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.riskMinimisationPlanMissing,
      },
      {
        type: "field",
        fieldType: "checkbox",
        key: "disabilityDiagnosisEvidenceMissing",
        label: "Disability/diagnosis evidence missing",
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "disabilityDiagnosisEvidenceMissingDetails",

        label: "Additional Description, if required",
        warnType: "information",
        warn: "This will be provided to the kindergarten",
        hideExpression: (formContext, values, model) => !model.disabilityDiagnosisEvidenceMissing,
      },
      {
        type: "field",
        fieldType: "error",
        key: "chooseOne",
        validation: yup.mixed().when(["$"], ([values]) => {
          return yup.mixed().test("chooseOne", "A response is required", () => oneChoosen(values));
        }),
      },
      {
        type: "field",
        fieldType: "textarea",
        key: "summary",
        label: "Summary",
        warn: "This will be provided to the kindergarten",
      },
      {
        type: "formGroup",
        key: "emailGroup",
        hideExpression: (context, values) => values.outdated || context.disabled,
        customWrapper: ({ children }: any) => (
          <div className="grid" style={{ maxWidth: "1250px" }}>
            {Children.map(children, (child) => (
              <div className="col-4">{child}</div>
            ))}
          </div>
        ),
        fields: [
          {
            type: "field",
            fieldType: "button",
            label: "Submit & Send First Email",
            key: "button",
            props: {
              className: "form-button",
            },
            expressionProps: {
              disabled: (context, values) => values.emailStatus != ChecklistEmailStatus.NoEmailSent && values.emailStatus != null,
              onClick: (context, values) => () => toggle(values),
            },
          },
          { type: "pInput", key: "emailLabel", label: "First Email Due Date" },
          {
            type: "field",
            fieldType: "calendar",
            key: "firstEmailDueDate",
            expressionProps: {
              disabled: (context, values) => values.emailStatus != ChecklistEmailStatus.NoEmailSent && values.emailStatus != null,
            },
            validation: yup.date().when(["$emailStatus"], ([emailStatus], schema) => {
              if (emailStatus !== ChecklistEmailStatus.NoEmailSent && emailStatus != null) {
                return schema.notRequired();
              }
              return schema
                .required("A response is required")
                .min(today, "The date must be a future date")
                .max(threeMonthsFuture, "The date may not be more than three (3) months in the future");
            }),
          },
          {
            type: "field",
            fieldType: "button",
            label: "Submit & Send First Reminder",
            key: "button",
            props: {
              className: "form-button",
            },
            expressionProps: {
              disabled: (context, values) => values.emailStatus != ChecklistEmailStatus.InitialEmail,
              onClick: (context, values) => () => {
                toggle(values);
              },
            },
          },
          { type: "pInput", key: "emailLabel", label: "First Reminder Email Due Date" },
          {
            type: "field",
            fieldType: "calendar",
            key: "firstReminderEmailDueDate",
            expressionProps: {
              disabled: (context, values) => values.emailStatus != ChecklistEmailStatus.InitialEmail,
            },
            validation: yup.date().when(["$emailStatus"], ([emailStatus], schema) => {
              if (emailStatus !== ChecklistEmailStatus.InitialEmail) {
                return schema.notRequired();
              }
              return schema
                .required("A response is required")
                .min(today, "The date must be a future date")
                .max(threeMonthsFuture, "The date may not be more than three (3) months in the future");
            }),
          },
          {
            type: "field",
            fieldType: "button",
            label: "Submit & Send Final Reminder",
            key: "button",
            props: {
              className: "form-button",
            },
            expressionProps: {
              disabled: (context, values) => values.emailStatus != ChecklistEmailStatus.FirstReminder,
              onClick: (context, values) => () => toggle(values),
            },
          },
          { type: "pInput", key: "emailLabel", label: "Final Reminder Email Due Date" },
          {
            type: "field",
            fieldType: "calendar",
            key: "finalReminderEmailDueDate",
            expressionProps: {
              disabled: (context, values) => values.emailStatus != ChecklistEmailStatus.FirstReminder,
            },
            validation: yup.date().when(["$emailStatus"], ([emailStatus], schema) => {
              if (emailStatus !== ChecklistEmailStatus.FirstReminder) {
                return schema.notRequired();
              }
              return schema
                .required("A response is required")
                .min(today, "The date must be a future date")
                .max(threeMonthsFuture, "The date may not be more than three (3) months in the future");
            }),
          },
        ],
      },
      {
        type: "field",
        key: "internalNotes",
        fieldType: "textarea",
        label: "Internal notes",
      },
    ],
  };
  return form;
};

export enum ChecklistEmailStatus {
  NoEmailSent = 0,
  InitialEmail = 1,
  FirstReminder = 2,
  LastReminder = 3,
}
function oneChoosen(values: any) {
  return (
    values.sectionOneNotProvided ||
    values.kindergartenNameMismatch ||
    values.teacherNameMissing ||
    values.teacherSignatureMissing ||
    values.eymSignatureMissing ||
    values.yearTeacherPreviouslyAccessedSupportMissing ||
    values.previousSupportTypeMissing ||
    values.attendanceHoursUnclearMissing ||
    values.kinderGroupNameMissing ||
    values.groupSizeMissing ||
    values.rotationalGroupsMissing ||
    values.staffToChildRatioMissing ||
    values.indoorOutdoorProgramMissing ||
    values.programOverviewSectionsBlank ||
    values.otherSupportDescriptionIncomplete ||
    values.section2NotProvided ||
    values.additionalStaffDescriptionMissing ||
    values.parentSignatureMissing ||
    values.applicationTypeMissing ||
    values.psgTableIncomplete ||
    values.psgConvenorNameMissing ||
    values.psgFirstMeetingDateMissing ||
    values.psgFutureDatedTBC ||
    values.childDOBMissing ||
    values.childGenderMissing ||
    values.birthInAustraliaOSBlank ||
    values.osBirthCountryMissing ||
    values.eslMissing ||
    values.languageSpokenMissing ||
    values.firstNationsOriginMissing ||
    values.parentDetailsBlank ||
    values.yearAppliedForMissing ||
    values.programTypeMissing ||
    values.secondYear4yoMissing ||
    values.childTurning6Missing ||
    values.schoolExemptionMissing ||
    values.commencementDateMissing ||
    values.secondRoundReasonMissing ||
    values.outOfRoundReasonMissing ||
    values.reasonsForSupportMissing ||
    values.disabilityDiagnosisMissing ||
    values.interestsMissing ||
    values.strengthsAndAbilitiesMissing ||
    values.physicalMissing ||
    values.fineMotorMissing ||
    values.communicationMissing ||
    values.learningMissing ||
    values.socialMissing ||
    values.selfCareMissing ||
    values.behavioursMissing ||
    values.evidenceCollectionLocationMissing ||
    values.kisPlanMissingIncomplete ||
    values.existingResourcesMissing ||
    values.allAdditionalSupportMissing ||
    values.additionalAssistantMissing ||
    values.specialistConsultancyMissing ||
    values.specialistTrainingMissing ||
    values.minorModificationsQuotesMissing ||
    values.cmnDiagnosisMissing ||
    values.healthSupportProceduresMissing ||
    values.frequencyOfMedicalSupportMissing ||
    values.whoWillProvideMedicalSupportMissing ||
    values.additionalMedicalTrainingMissing ||
    values.medicalManagementPlanMissing ||
    values.riskMinimisationPlanMissing ||
    values.disabilityDiagnosisEvidenceMissing
  );
}
